/* istanbul ignore file */

import * as React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { setXIdSociete, useSociete } from '@europrocurement/l2d-domain';
import Router from './router/router';
import L2DTheme from './Theme';
import { useAppDispatch } from './redux/types';

const router = createBrowserRouter(Router);

const App = function () {
    const theme = L2DTheme();
    const xIdSociete = useSociete();

    const dispatch = useAppDispatch();

    React.useEffect(() => {
        if (xIdSociete !== 12) {
            dispatch(setXIdSociete(12));
        }
    });

    return (
        <ThemeProvider theme={theme}>
            <RouterProvider router={router} />
            <CssBaseline />
        </ThemeProvider>
    );
};

export default App;
